import theme from '../../theme';
export var variantMapping = {
    h4: {
        fontSize: theme.typography.font.size.xxLarge,
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.bold,
        lineHeight: '2.5rem',
        letterSpacing: '-0.6000000238418579px',
        scaleFactor: 1.25,
    },
    h5: {
        fontSize: theme.typography.font.size.xLarge,
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.bold,
        lineHeight: '2rem',
        letterSpacing: '-0.5px',
        scaleFactor: 1.3333,
    },
    h6: {
        fontSize: theme.typography.font.size.large,
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.bold,
        lineHeight: '1.625rem',
        letterSpacing: '-0.3px',
        scaleFactor: 1.25,
    },
    subtitle1: {
        fontSize: theme.typography.font.size.medium,
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.regular,
        lineHeight: '1.5rem',
        letterSpacing: '-0.3px',
        scaleFactor: 1.125,
    },
    subtitle2: {
        fontSize: theme.typography.font.size.small,
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.regular,
        lineHeight: '1.375rem',
        letterSpacing: '-0.3px',
        scaleFactor: 1.1428,
    },
    button: {
        fontSize: theme.typography.font.size.small,
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.regular,
        lineHeight: '1.5rem',
        letterSpacing: '-0.3px',
        scaleFactor: 1,
    },
    caption: {
        fontSize: theme.typography.font.size.xSmall,
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.regular,
        lineHeight: '1rem',
        letterSpacing: '-0.3px',
        scaleFactor: 1.125,
    },
    overline: {
        fontSize: '0.6875rem',
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.regular,
        lineHeight: '1rem',
        letterSpacing: '-0.3px',
        scaleFactor: 1,
    },
    micro: {
        fontSize: '0.625rem',
        fontFamily: theme.typography.font.family.latoVerdana,
        fontWeight: theme.typography.font.lato.weight.regular,
        lineHeight: '0.75rem',
        letterSpacing: '-0.3px',
        scaleFactor: 1,
    },
};
